import axios from "axios";
import { formatarDadosParaHeatMap } from "../util/utilitarios";
import { toastErrorPydantic } from "../util/toast_pydantic";

const indicadorGraficosApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND}/indicador/graficos/`
})

const indicadorTabelasApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND}/indicador/tabelas/`
})

// Grafico Barras
const servGetGraficoAlcanceMensal = async (dataInicio, dataFim) => {
    const { data } = await indicadorGraficosApi.get('mv/alcance-mensal', {
        params: { dataInicio, dataFim }
    })
    return data;
}

// Graficos Detalhamento Métrica/Estabelecimento
async function servGetGraficoDetalhamentoMetrica(dataInicio, dataFim, estabelecimentoId) {
    const { data } = await indicadorGraficosApi.get('mv/detalhamento-metrica', {
        params: { dataInicio, dataFim, estabelecimentoId }
    })
    return data

}

// Grafico HeatMap
async function servGetGraficoPercentualAlcanceUnidades(dataInicio, dataFim) {
    const { data } = await indicadorGraficosApi.get('mv/percentual-alcance-unidades', {
        params: { dataInicio, dataFim }
    })
    return data
}

// Tabela Indicadores Estabelecimento
async function servGetTabelaIndicadoresEstabelecimento(dataInicio, dataFim, estabelecimentoId) {
    const { data } = await indicadorTabelasApi.get('mv/indicadores-estabelecimento', {
        params: { dataInicio, dataFim, estabelecimentoId }
    })
    return data
}

export {
    servGetGraficoAlcanceMensal,
    servGetGraficoDetalhamentoMetrica,
    servGetGraficoPercentualAlcanceUnidades,
    servGetTabelaIndicadoresEstabelecimento
}